module.exports = __webpack_public_path__ + "svg/flags/South Georgia and the South Sandwich Islands.svg";